import React from "react";
import style from "css/landing.module.css";
import ProjectItem from "./projectItem";
import { useMediaQuery } from "react-responsive";

function Project(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const projectList = [
    {
      img:
        !isMobile && !isTablet
          ? "img/landing/medi_link.png"
          : "img/landing/medi_link_m.png",
      customer: "Medi Link",
      title: "<span>한림대학교의료원</span> 화상 회진 시스템",
      text:
        !isMobile && !isTablet
          ? "리브테크놀로지의 Be Gate제품을 활용하여 EMR 시스템과 Zoom을 연동하여\n국내 최초의 Zoom 기반 화상 회진 시스템을 구축했습니다."
          : "리브테크놀로지의 Be Gate제품을 활용하여 EMR 시스템과 Zoom을 연동하여 국내 최초의 Zoom 기반 화상 회진 시스템을 구축했습니다.",
    },
    {
      img:
        !isMobile && !isTablet
          ? "img/landing/all_place.png"
          : "img/landing/all_place_m.png",
      customer: "all Place",
      title: "<span>삼성생명</span> 화상회의 및 회의실 예약 시스템 구축",
      text:
        !isMobile && !isTablet
          ? "리브테크놀로지의 all Place 솔루션을 기반으로 화상회의 예약 포털을 구축하였으며, 회의실 예약부터\n회의 일정 확인, 실시간 제어 기능까지 통합 제공하여 효율적인 회의 운영 환경을 구현하였습니다."
          : "리브테크놀로지의 all Place 솔루션을 기반으로 화상회의 예약 포털을 구축하였으며, 회의실 예약부터 회의 일정 확인, 실시간 제어 기능까지 통합 제공하여 효율적인 회의 운영 환경을 구현하였습니다.",
    },
    {
      img:
        !isMobile && !isTablet
          ? "img/landing/neat.png"
          : "img/landing/neat_m.png",
      customer: "neat.",
      title: "<span>쿠팡</span> 화상회의 인프라 구축",
      text:
        !isMobile && !isTablet
          ? "리브테크놀로지는 쿠팡의 회의실에 Neat Bar 및 Pad 제품 약 200대를 공급하였으며,\n스마트워크 환경에 적합한 화상회의 인프라를 구축하였습니다."
          : "리브테크놀로지는 쿠팡의 회의실에 Neat Bar 및 Pad 제품 약 200대를 공급하였으며, 스마트워크 환경에 적합한 화상회의 인프라를 구축하였습니다.",
    },
  ];
  return (
    <div className={style.project_wrap} ref={props.ref}>
      <div className={style.project_background_title}>OUR PROJECT</div>
      <div className={style.project_list}>
        {projectList.map((project, index) => (
          <ProjectItem project={project} key={index} />
        ))}
      </div>
    </div>
  );
}

export default Project;
